import React, { useState, useEffect } from 'react'
import { createEventAPI } from '../../../api/event';
import { hundleRequestFailure } from '../../../functions/hundle_request_failure';
import { showAlert } from '../../../functions/show_alert';
import { HideProgressAlert, showProgressAlert } from '../../../functions/show_progress_page';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import './create_event.css';
import { useDispatch } from 'react-redux';
import { changeProjectEvent } from '../../../redux/project/projects';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { youtubeRegex } from '../../../global/http_enum';
import MapLocationDialog from '../../posters/poster_wizard/country_map/map_location_dialog';
export default function CreationOfEvent({ projectSelected, onBack }) {
    const [eventType, SetEventType] = useState('Theory');

    // Directly show the dialog, no intermediate screen
    return <CreatEventScreen eventType={eventType} projectSelected={projectSelected} onBack={onBack} setEventType={SetEventType} />
}
const CreatEventScreen = ({ projectSelected, eventType, onBack, setEventType }) => {
    const dispatch = useDispatch();
    const [currentEventType, setCurrentEventType] = useState(eventType);

    // Update parent's eventType when changed
    const handleEventTypeChange = (newType) => {
        setCurrentEventType(newType);
        if (setEventType) {
            setEventType(newType);
        }
    }
    const [file, SetFile] = useState(); // For uploaded file (base64)
    const [youtubeLink, setYoutubeLink] = useState(''); // For YouTube link (separate from file)
    const [showMap, SetShowMap] = useState(false);
    const [eventName, SetEventName] = useState('');
    const [eventDesc, SetEventDesc] = useState('');
    const [negative, SetNegative] = useState('');
    const [problem, SetProblem] = useState('');
    const [eventDate, SetEventDate] = useState('');
    const [clickedLocation, setClickedLocation] = useState(null);
    const [location, SetLocation] = useState('');
    const [uploadedFileName, setUploadedFileName] = useState(null);

    useEffect(() => {
        if (clickedLocation != null) {
            SetLocation(clickedLocation);
        }
    }, [clickedLocation])

    const handleSaveLocation = (locationData) => {
        if (locationData && locationData.address) {
            SetLocation(locationData.address);
            setClickedLocation(locationData.address);
        }
        SetShowMap(false);
    };

    const handleShowMap = () => {
        SetShowMap(true);
    };

    const HundleFileUpload = (pickedFile) => {
        if (pickedFile.size > 10000000) {
            showAlert(false, 'the file Size is More then 10 MB');
            return;
        }
        if (pickedFile) {
            const reader = new FileReader();
            reader.onloadend = () => {
                const base64String = btoa(reader.result);
                SetFile(base64String);
                setUploadedFileName(pickedFile.name);
                // Don't clear YouTube link when file is uploaded
            };
            reader.readAsBinaryString(pickedFile);
        }
    }

    const hundleCreateEvent = async () => {
        if (eventName === '') {
            showAlert(false, 'Event name is Required');
            return;
        }
        if (eventDesc === '') {
            showAlert(false, 'Event Description is Required');
            return;
        }
        if (location === '') {
            showAlert(false, 'Event Location is Required');
            return;
        }
        if (negative === '') {
            showAlert(false, 'Negative Function Executed is Required');
            return;
        }
        if (eventDesc === '') {
            showAlert(false, 'Event Description is Required');
            return;
        }
        if (problem === '') {
            showAlert(false, 'Problem Identified from Event is Required');
            return;
        }
        if (eventDate === '') {
            showAlert(false, 'Event Date is Required');
            return;
        }
        // Validate YouTube link if provided
        if (youtubeLink) {
            const match = youtubeLink.match(youtubeRegex);
            if (!match) {
                showAlert(false, "Oops! It looks like the YouTube link you've entered doesn't match the expected format. To ensure smooth processing, please use the 'Share' link directly from YouTube.  ")
                return;
            }
        }
        showProgressAlert();
        // Send both file and link separately
        console.log('Creating event with location:', location);
        const response = await createEventAPI(
            eventName,
            location,
            eventDesc,
            negative,
            problem,
            projectSelected.id,
            file || null, // Send uploaded file if exists
            currentEventType,
            eventDate,
            youtubeLink || null, // Send YouTube link if exists
        );
        console.log('Event created, response:', response);
        HideProgressAlert();
        if (response.statusCode === 200) {
            console.log('Event created successfully, event data:', response.response);
            console.log('Event location in response:', response.response?.location);
            showAlert(true, 'Event Created Successfully !')
            dispatch(changeProjectEvent({ id: projectSelected.id, event: response.response }));
            if (onBack) {
                onBack();
            }
        } else {
            hundleRequestFailure(response)
        }
    }


    const handleYoutubeChange = (value) => {
        setYoutubeLink(value || '');
        // Don't clear uploaded file when YouTube link is entered
    }


    return (
        <div className="create-event-screen">
            <div className="create-event-form">
                <div className="wizard-header">
                    <h1 className="wizard-title">Create New Event</h1>
                </div>
                <div className="domain-pills">
                    <button
                        className={`domain-pill ${currentEventType === 'Theory' ? 'active' : ''}`}
                        onClick={() => handleEventTypeChange('Theory')}
                    >
                        Theory Domain
                    </button>
                    <button
                        className={`domain-pill ${currentEventType === 'Communication' ? 'active' : ''}`}
                        onClick={() => handleEventTypeChange('Communication')}
                    >
                        Communication Domain
                    </button>
                </div>

                <div className="form-container">
                    <div className="form-field field-order-1">
                        <label className="field-label">Event Name*</label>
                        <input
                            type="text"
                            className="form-input"
                            placeholder="Type here"
                            value={eventName}
                            onChange={(e) => SetEventName(e.target.value)}
                        />
                    </div>

                    <div className="form-field field-order-2">
                        <label className="field-label">Event Location*</label>
                        <div className="location-input-wrapper">
                            <input
                                type="text"
                                className="form-input disabled-input"
                                placeholder="Select location from Event Map"
                                value={location}
                                onChange={(e) => SetLocation(e.target.value)}
                                disabled={true}
                            />
                            <LocationOnIcon className="location-icon" />
                        </div>
                    </div>

                    <div className="form-field field-order-3">
                        <label className="field-label">Event Date*</label>
                        <div className="date-input-wrapper">
                            <input
                                type="date"
                                id="event-date-input"
                                className="form-input date-input"
                                placeholder="MM/DD/YYYY"
                                value={eventDate}
                                onChange={(e) => SetEventDate(e.target.value)}
                            />
                            <CalendarTodayIcon
                                className="calendar-icon"
                                onClick={() => {
                                    const dateInput = document.getElementById('event-date-input');
                                    if (dateInput) {
                                        dateInput.focus();
                                        if (dateInput.showPicker) {
                                            dateInput.showPicker();
                                        } else {
                                            dateInput.click();
                                        }
                                    }
                                }}
                            />
                        </div>
                    </div>

                    <div className="form-field field-order-4">
                        <label className="field-label">Negative Function Executed*</label>
                        <input
                            type="text"
                            className="form-input"
                            placeholder="Type here"
                            value={negative}
                            onChange={(e) => SetNegative(e.target.value)}
                        />
                    </div>

                    <div className="form-field field-order-5">
                        <label className="field-label">Problem Identified from Event*</label>
                        <input
                            type="text"
                            className="form-input"
                            placeholder="Type here"
                            value={problem}
                            onChange={(e) => SetProblem(e.target.value)}
                        />
                    </div>

                    <div className="form-field field-order-6">
                        <label className="field-label">Event Description*</label>
                        <ReactQuill
                            className="problem-quill"
                            theme="snow"
                            value={eventDesc}
                            onChange={SetEventDesc}
                            placeholder="Type here"
                        />
                    </div>
                </div>

                <div className="media-section">
                    <div className="media-row">
                        <div className="form-field youtube-field">
                            <label className="field-label">Youtube Link</label>
                            <input
                                type="text"
                                className="form-input"
                                placeholder="Insert link"
                                value={youtubeLink}
                                onChange={(e) => handleYoutubeChange(e.target.value)}
                            />
                        </div>

                        <div className="form-field event-map-field">
                            <label className="field-label">Event Map</label>
                            <button className="event-map-button" onClick={handleShowMap}>
                                Click to Show Map
                                <LocationOnIcon className="event-map-icon" />
                            </button>
                        </div>
                    </div>

                    <div className="form-field">
                        <label className="field-label">Upload Files</label>
                        <div
                            className={`file-upload-area ${uploadedFileName ? 'has-file' : ''}`}
                            onClick={() => {
                                document.getElementById('file-input').click();
                            }}
                        >
                            <input
                                id="file-input"
                                type="file"
                                style={{ display: 'none' }}
                                accept=".jpg,.jpeg,.png,.pdf"
                                onChange={(e) => {
                                    if (e.target.files && e.target.files[0]) {
                                        HundleFileUpload(e.target.files[0]);
                                    }
                                }}
                            />
                            <CloudUploadIcon className="upload-icon" />
                            <p className="upload-text">Upload the file here</p>
                            <p className="upload-hint">(Only .jpg, .png, & .pdf files will be accepted)</p>
                            {uploadedFileName && (
                                <p className="uploaded-file">{uploadedFileName}</p>
                            )}
                        </div>
                        {!uploadedFileName && (
                            <p className="no-files-text">no files uploaded yet</p>
                        )}
                    </div>
                </div>

                <div className="form-footer">
                    <button className="footer-button primary" onClick={hundleCreateEvent}>
                        Create
                    </button>
                </div>

                <MapLocationDialog
                    isOpen={showMap}
                    onClose={() => SetShowMap(false)}
                    onSaveLocation={handleSaveLocation}
                    initialLocation={location || 'USA'}
                />
            </div>
        </div>
    )
}
